// extracted by mini-css-extract-plugin
export default {"axisLine":"BarChart_axisLine__uGe8M","bar":"BarChart_bar__CEXHd"};